import { Image as rImage } from 'react-native'
import { createThemedComponent } from '../css/create-themed-component'

export const Image = createThemedComponent(rImage)
